export default "__VITE_PUBLIC_ASSET__2dc92a86__"